module.exports = __webpack_public_path__ + "bafb948afe33e67f90f326510d0e1c3f.png";